import FacebookIcon from '@repo/ui/src/components/Icons/FacebookIcon';
import TwitterIcon from '@repo/ui/src/components/Icons/TwitterIcon';
import InstagramIcon from '@repo/ui/src/components/Icons/InstagramIcon';
import YoutubeIcon from '@repo/ui/src/components/Icons/YoutubeIcon';
import PinterestIcon from '@repo/ui/src/components/Icons/PinterestIcon';
import TikTokIcon from '@repo/ui/src/components/Icons/TikTokIcon';

interface Props {
  darkMode?: boolean;
  width?: string;
  facebook?: string;
  instagram?: string;
  twitter?: string;
  pinterest?: string;
  youtubeUser?: string;
  youtube?: string;
  tiktok?: string;
  website?: string;
}

const componentTypes = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
  youtubeUser: YoutubeIcon,
  pinterest: PinterestIcon,
  tiktok: TikTokIcon,
};

type SocialOption = keyof typeof componentTypes;
type Func = (link: string) => string;
const socialLinks: Record<SocialOption, Func> = {
  facebook: (link) => `https://www.facebook.com/${link}`,
  instagram: (link) => `https://www.instagram.com/${link}/`,
  twitter: (link) => `https://x.com/${link}`,
  pinterest: (link) => `https://www.pinterest.com/${link}/`,
  youtubeUser: (link) => `https://www.youtube.com/user/${link}`,
  youtube: (link) => `https://www.youtube.com/${link}`,
  tiktok: (link) => `https://www.tiktok.com/@${link}`,
};

const Icon = (props: {
  width: string;
  frontFillColor: string;
  backFillColor: string;
  network: string;
}) => {
  const Component = componentTypes[props.network as SocialOption];
  if (!Component) return null;
  return <Component {...props} />;
};

const SocialLinks = ({ darkMode = false, width = '40px', ...networks }: Props) => {
  const backgroundColor = darkMode
    ? 'var(--tra-color-neutral-500)'
    : 'var(--tra-color-neutral-600)';

  return (
    <ul className="flex-row p-0 grid grid-flow-col gap-2 w-fit list-none">
      {Object.entries(networks).map(([key, value], index) => {
        const link = value && socialLinks[key as SocialOption]?.(value);

        if (!link) return null;

        return (
          <li key={index}>
            <a href={link} rel="noreferrer" target="_blank" aria-label={key}>
              <Icon
                backFillColor={backgroundColor}
                frontFillColor="white"
                width={width}
                network={key}
              />
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialLinks;
